export default "__VITE_ASSET__app9XVme__"